import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=6de3dd70&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=6de3dd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3dd70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de3dd70')) {
      api.createRecord('6de3dd70', component.options)
    } else {
      api.reload('6de3dd70', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=6de3dd70&scoped=true&", function () {
      api.rerender('6de3dd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21KmikSc8NCRT/JS/comp/PopupBox.vue"
export default component.exports